import { useState } from "react";
import {
  ControllerReEntryListWrapper,
  ControllerReEntryListItem,
  ControllerReEntryListItemInfo,
} from "../style";
import { useDialogPayTypes } from "../../../hooks/useDialogPayTypes";
import {
  ParticipantDto,
  PaymentMethod,
} from "../../../../../../../api/tournament-participant";
import { PaginationWrapper } from "../../../../../../../component/CommonTable";
import PopupPagination from "../../../../../../../component/Pagination/popupPagination";
import MoreInfo from "../../more";
import { formatDate } from "../../../../../../../utils/date";
import { Const } from "../../../../../../../common/const/const";

interface ReBuyInAddOnListProps {
  isAddOn: boolean;
  list: ParticipantDto[];
  isCount: boolean;
  totalPage: number;
  currentPage: number;
  setCurrentPage: (value: number) => void;
  deleteItem: (value: ParticipantDto, index: number) => void;
}
const ControllerReEntryList = ({
  isAddOn,
  list,
  isCount,
  totalPage,
  currentPage,
  setCurrentPage,
  deleteItem,
}: ReBuyInAddOnListProps) => {
  const { dialogPayType, resetDialogPayType, handleSetPaymentValues } =
    useDialogPayTypes();
  const [isHover, setIsHover] = useState<number>(0);

  const onPageChange = async (nextPage: number) => {
    setCurrentPage(nextPage);
  };

  const handlePayAmount = (item: ParticipantDto) => {
    if (item.id < 0) return item.paymentAmount;
    if (
      item.paymentMethodRequests.some(
        (pay) => pay.paymentMethod === PaymentMethod.SEED
      )
    ) {
      let result = 0;
      item.paymentMethodRequests.forEach((pay) => {
        if (pay.paymentMethod !== PaymentMethod.SEED) {
          result += pay.paymentAmount;
        } else {
          result += pay.paymentAmount * Const.SEED_RATE;
        }
      });
      return result;
    }
    return item.paymentAmount;
  };

  const getCountType = (item: any) => {
    if (item.id >= 0) {
      return item.isCount ? "Y" : "N";
    }

    return isCount ? "Y" : "N";
  };

  const handleMore = (item: ParticipantDto) => {
    handleSetPaymentValues(item, item.id < 0);
    setIsHover(item.id);
  };

  const handleMoreOut = () => {
    resetDialogPayType();
    setIsHover(0);
  };

  return (
    <ControllerReEntryListWrapper>
      <div className="title">{isAddOn ? "애드온" : "리엔트리"} 목록</div>
      <div className="list-box">
        {list.map((item, index) => (
          <ControllerReEntryListItem className={`${item.id >= 0 && "overlay"}`}>
            <div>
              {formatDate(item.createdAt.toString(), false)}(LV {item.level})
            </div>
            <ControllerReEntryListItemInfo>
              <div className="pay">
                {handlePayAmount(item).toLocaleString()}원
                {isAddOn && `(${getCountType(item)})`}
                <div
                  className="more"
                  onMouseOver={() => handleMore(item)}
                  onMouseOut={() => handleMoreOut()}
                >
                  <img src="/image-web/solution/more.png" alt="자세히 보기" />
                </div>
                {isHover === item.id && (
                  <MoreInfo
                    name={isAddOn ? "애드온 내역" : "리엔트리 내역"}
                    addStack={item.addStack}
                    dialogPayType={dialogPayType}
                  />
                )}
              </div>
              {item.id < 0 ? (
                <div className="red" onClick={() => deleteItem(item, index)}>
                  삭제
                </div>
              ) : (
                <div className="box" />
              )}
            </ControllerReEntryListItemInfo>
          </ControllerReEntryListItem>
        ))}
      </div>
      {totalPage >= 1 && (
        <PaginationWrapper style={{ padding: "10px 0" }}>
          <PopupPagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={onPageChange}
          />
        </PaginationWrapper>
      )}
    </ControllerReEntryListWrapper>
  );
};

export default ControllerReEntryList;
